// «В отъезде до» (032: data-model.md, `directory.absences`; contracts/api.md, my.away и people.away;
// FR-023; ASG-NTF-15). Сам человек — в «Моих задачах», контролёр — во вкладке «Ответственные». На эти
// даты копия руководителю на паузе, письма ритма ждут; после возврата — «Пока вас не было: …».
import { z } from '../kernel/zod.ts';
import { DateSchema, IdSchema, TimestampSchema } from '../kernel/common.ts';

/** PUT /api/my/away и PUT /api/people/{personId}/away: последний день отъезда включительно. */
export const AbsenceBodySchema = z.strictObject({ until: DateSchema });
export type AbsenceBody = z.input<typeof AbsenceBodySchema>;

export const AbsenceSchema = z.object({
  personId: IdSchema,
  until: DateSchema,
  setBy: z.enum(['self', 'controller']),
  setAt: TimestampSchema,
});
export type Absence = z.infer<typeof AbsenceSchema>;

/** Человек в адресе people.away. */
export const PersonParamsSchema = z.strictObject({ personId: IdSchema });
